import _extends from "@babel/runtime/helpers/esm/extends";
import { getType } from 'typesafe-actions';
import { localeConfigActions } from './actions';
export var initialState = {
  meta: {},
  language: 'en'
};
export var reducer = function reducer(state, action) {
  if (state === void 0) {
    state = initialState;
  }

  switch (action.type) {
    case getType(localeConfigActions.setLanguage):
      return _extends({}, state, {
        language: action.payload
      });

    default:
      return state;
  }
};